export enum IdAnnotations {
  ConvenzioniMatrimoniali = '301',
  SeparazioneDeiBeni = '302',
  AltraLegge = '303',
}
